const cache = {}

export default (src, async = true) =>
  new Promise((resolve, reject) => {
    if (cache[src]) {
      return resolve()
    }
    const script = document.createElement('script')
    script.src = src
    if (async) {
      script.async = true
    }
    script.onload = () => {
      cache[src] = true
      resolve()
    }
    script.onerror = reject
    document.head.appendChild(script)
  })
